/**
 * Утилита updateLogoVisibility — управление прозрачностью логотипа при скролле
 *
 * Основные функции:
 * - Рассчитывает долю прокрутки страницы
 * - Плавно скрывает логотип при прокрутке вниз (opacity: 1 → 0)
 * - Полностью убирает элемент (display: none) когда он невидим
 *
 * @param logoElement — DOM-элемент логотипа
 */
export const updateLogoVisibility = (logoElement: HTMLElement) => {
  // Текущая позиция скролла
  const scrollY = window.scrollY
  // Максимальная прокрутка страницы
  const maxScroll = document.body.scrollHeight - window.innerHeight
  // Доля прокрутки от 0 до 1
  const scrollFraction = Math.min(scrollY / maxScroll, 1)

  // Рассчитываем opacity — быстро уменьшается (множитель 5)
  const opacity = 1 - scrollFraction * 5

  // Применяем opacity и display напрямую к элементу
  logoElement.style.opacity = String(Math.max(opacity, 0))
  logoElement.style.display = opacity <= 0 ? 'none' : ''
}
